import {createContext} from 'react';

import type {Infinity} from '../services/InfinityClient.service';

export const InfinityContext = createContext<Infinity | undefined>(undefined);
